import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isValidDate, singleAlphabet } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedIntersalonikaFields = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  let schema = {
    ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
    nationality: legalEntity ? yup.string().required() : yup.string(),
    only_driver: yup.boolean().required(),
    license_cat: yup.string().required(),
    tax_office: yup.string().required(),
    co_owner: yup.boolean().required(),
  };

  if (firstDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate: yup
        .object({
          day: yup.string().required(),
          month: yup.string().required(),
          year: yup.string().required(),
        })
        .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate)
        .required(),
    };
  }

  if (secondDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate2: yup.object().when('only_driver', {
        is: false,
        then: (s) =>
          s
            .shape({
              day: yup.string().required(),
              month: yup.string().required(),
              year: yup.string().required(),
            })
            .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
      }),
    };
  }

  if (!legalEntity) {
    schema = {
      ...schema,
      name: singleAlphabet(schema.name),
      surname: singleAlphabet(schema.surname),
    };
  }

  schema = {
    ...schema,
    name2: yup.string().when('only_driver', {
      is: false,
      then: (s) => s.required(),
    }),
    surname2: yup.string().when('only_driver', {
      is: false,
      then: (s) => s.required(),
    }),
  };

  return schema;
};

export const sharedIntersalonikaSchemaBuilder = (...args) => yup.object(sharedIntersalonikaFields(...args));
export default sharedIntersalonikaSchemaBuilder;
